<template>
    <MainContentSearchable title="Listado de plazos" id="plazos-impagados" v-model="filters_local" :meta="loading ? {} : plazos.meta" @updated="actualizar">
        <template v-slot:header>
            <h3>
                Listado de plazos
            </h3>
        </template>
        <template v-slot:extra-options>
            <div class="mt-2 d-flex justify-content-start align-items-center">
                <div class="mr-3">
                    <Button @click="showModal('descargar-plazos')">Descargar</Button>
                    <DescargarListadoPlazos :filters="filters_local" :lista_id="lista_id" :tipo="sonAbonos ? 'abono' : 'base'" @close="closeModal('descargar-plazos')"/>
                </div>
                <div class="d-flex col-auto" v-if="sonAbonos">
                    <Button :disabled="tienenFalloDefinitivo" @click="showModal('avisos-plazos')">Enviar avisos</Button>
                    <template v-if="!sonAbonos">
                        <div style="position: absolute; left: 8em;">
                            <InfoToolTip :info="'Este botón es para enviar un aviso por email al usuario asociado al plazo, cuando hay plazos FALLIDOS DEFINITIVOS, en caso de no haberlos estará desactivado.'" />
                        </div>
                    </template>
                    <div v-else style="position: absolute; left: 8em;">
                        <InfoToolTip :info="'Enviar email a todos los abonados que tengan plazos fallidos DEFINITIVOS, para informarles de que su abono se anulará hasta que paguen'" />
                    </div>
                </div>
                <EnviarAvisos v-if="!tienenFalloDefinitivo" :sonAbonos="sonAbonos" :loading="loading" @close="closeModal" @terminado="enviarAvisos()"/>
                <select class="custom-select w-auto mr-5" id="estado" v-model="filters_local.estado" @change="actualizar()">
                    <option value="">Estado</option>
                    <option value="0">Pendiente</option>
                    <option value="1">Pagado</option>
                    <option value="2">Anulado</option>
                    <option value="3">Fallido</option>
                    <option value="4">Fallido definitivo</option>
                    <option value="5">Bloqueado</option>
                </select>
                <input type="date" class="p-2 mr-4" v-model="filters_local.fecha" @change="actualizar()"/>
            </div>
        </template>
        <template v-slot:content>
            <div class="mt-2 d-flex justify-content-end align-items-center">
                <p class="mr-4"><span class="bg-green rounded-circle" style="padding: 0px 13px 0px 4px"><span hidden>r</span></span> <b class="pl-1">PAGADO</b></p>
                <p class="mr-4"><span class="bg-secondary rounded-circle" style="padding: 0px 13px 0px 4px"><span hidden>r</span></span> <b class="pl-1">PENDIENTE</b></p>
                <p class="mr-4"><span class="bg-dark rounded-circle" style="padding: 0px 13px 0px 4px"><span hidden>r</span></span> <b class="pl-1">ANULADO</b></p>
                <p class="mr-4"><span class="bg-warning rounded-circle" style="padding: 0px 13px 0px 4px"><span hidden>r</span></span> <b class="pl-1">FALLIDO</b></p>
                <p class="mr-4"><span class="bg-danger rounded-circle" style="padding: 0px 13px 0px 4px"><span hidden>r</span></span> <b class="pl-1">FALLIDO DEFINITIVO</b></p>
            </div>
            <div v-if="!loading">
                <ListadoPlazosImpagados :plazos="plazos" :sonAbonos="sonAbonos" :lista_id="lista_id" @actualizado="actualizar" />
            </div>
            <LoaderComponent v-else />
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import ListadoPlazosImpagados from "@/components/common/plazos/ListadoPlazosImpagados";
    import EnviarAvisos from './modals/EnviarAvisos';
    import InfoToolTip from '@/components/common/InfoToolTip';
    import DescargarListadoPlazos from './modals/DescargarListadoPlazos';

    export default {
        props: ['plazos', 'filters', 'lista_id'],
        data() {
            return {
                loading: false,
                filters_local: {...this.filters}
            }
        },
        watch: {
            filters_local: {
                handler(newVal) {
                    this.$emit('update:filters', newVal);
                },
                deep: true
            }
        },
        methods: {
            actualizar() {
                if (!this.debouncedGetPlazos) {
                    this.debouncedGetPlazos = _.debounce(() => {
                        this.$emit('actualizado');
                    }, 500);
                }
                this.debouncedGetPlazos();
            },
            enviarAvisos() {
                this.loading = true;

                let params = {
                    filters: {},
                    lista_id: this.lista_id,
                    tipo: this.sonAbonos ? 'abonos' : 'bases'
                }
                this.$store.dispatch(this.config.getVuexAlias('back.plazos-impagados.enviar-avisos'), params).then(() => {
                    this.$toast.success('Avisos enviados correctamente.');
                    this.closeModal('avisos-plazos');
                    this.actualizar();
                }).finally(() => this.loading = false);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
        },
        computed: {
            tienenFalloDefinitivo() {
                if (this.plazos.data) {
                    if (this.plazos.data.filter(plazo => plazo.estado == 4 && !plazo.inactivo).length > 0) {
                        return false;
                    } else {
                        return true;
                    }
                }

                return true;
            },
            sonAbonos() {
                return document.location.href.indexOf('abonos') !== -1;
            }
        },
        components: {
            MainContentSearchable, ListadoPlazosImpagados, EnviarAvisos, InfoToolTip, DescargarListadoPlazos
        }
    }
</script>